import { Enumify } from "enumify";

class Global extends Enumify {
  static text = new Global({
    name: "인쇄광고",
  });
  static video = new Global({
    name: "동영상광고",
  });
  static _ = this.closeEnum();

  constructor(props) {
    super();
    Object.defineProperties(this, Object.getOwnPropertyDescriptors(props));
  }
}

export default Global;
